import * as React from 'react';
import { snap, visualize } from 'storybook-snapper';
import { Grid } from '..';
import { LegacyCard } from '../LegacyCard';

const expectedListWidth = 520;
const expectedMaxItemsPerRow = 5;
const expectedMinItemWidth = 120;
const expectedColumnGap = 10;
const expectedRowGap = 10;

const generateItems = (amount = 5) => {
  return Array(amount)
    .fill(null)
    .map((_, index) => {
      return (
        <Grid.Item key={`key-${index}`}>
          <LegacyCard stacked info={<div>info-{index + 1}</div>} />
        </Grid.Item>
      );
    });
};

const DefaultGrid = () => {
  return (
    <Grid
      width={expectedListWidth}
      maxColumns={expectedMaxItemsPerRow}
      minColumnWidth={expectedMinItemWidth}
      columnGap={expectedColumnGap}
      rowGap={expectedRowGap}
    >
      {generateItems(5)}
    </Grid>
  );
};

visualize('Grid', () => {
  snap('default layout', <DefaultGrid />);
});
